const img = require('./chevron_left_m_action.png'); export default img;